import { getUserAuthTokens } from '@billx/utils';

import { userApiClient } from '../clients';
import type { AuthResponse, NucleusServiceResponse } from './types';
import { handleAxiosError } from './utils';

export class UserAuthService {
  /**
   * Request OTP for login/signup
   */
  static async requestOtp(
    phone: string
  ): Promise<NucleusServiceResponse<{ message: string }>> {
    try {
      const response = await userApiClient.post<
        NucleusServiceResponse<{ message: string }>
      >('/user/auth/otp/request', { phone });
      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to request OTP');
    }
  }

  /**
   * Verify OTP to complete login/signup
   */
  static async verifyOtp(payload: {
    phone: string;
    otp: string;
    referralCode?: string;
    invitationCode?: string;
    deviceId?: string;
    deviceInfo?: {
      type: string;
      platform?: string;
      deviceName?: string;
      model?: string;
      browser?: string;
      osVersion?: string;
      appVersion?: string;
    };
  }): Promise<NucleusServiceResponse<AuthResponse>> {
    try {
      const response = await userApiClient.post<
        NucleusServiceResponse<AuthResponse>
      >('/user/auth/otp/verify', payload);
      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to verify OTP');
    }
  }

  /**
   * Refresh user auth tokens
   */
  static async refreshTokens(
    deviceId?: string
  ): Promise<NucleusServiceResponse<AuthResponse>> {
    try {
      const { refreshToken } = getUserAuthTokens();
      const response = await userApiClient.post<
        NucleusServiceResponse<AuthResponse>
      >('/user/auth/refresh', { refreshToken, deviceId });

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to refresh user auth tokens');
    }
  }

  /**
   * Logout user
   */
  static async logout(
    deviceId?: string
  ): Promise<NucleusServiceResponse<{ message: string }>> {
    try {
      const { refreshToken } = getUserAuthTokens();
      const response = await userApiClient.post<
        NucleusServiceResponse<{ message: string }>
      >('/user/auth/logout', { refreshToken, deviceId });

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to logout user');
    }
  }
}
